import { useMutation, useQuery } from '@tanstack/react-query'
import { store } from '../..'
import { announcements } from '../../../api/hr/announcements'
import { queryClient } from '../../..'
import moment from 'moment'
import { setAlert, setIsLoading } from '../../components/components-slice'

export function useGetAnnouncementsCount() {
  return useQuery(
    ['announcement-count'],
    () => {
      store.dispatch(setIsLoading(true))
      return announcements.getAnnouncementCount()
    },
    {
      onSettled: () => {
        store.dispatch(setIsLoading(false))
      },
      // keepPreviousData: true
    }
  )
}

export function useGetAllAnnouncements(limit, page, search) {
  return useQuery(
    ['all-announcements', { limit, page, search }],
    () => {
      store.dispatch(setIsLoading(true))
      return announcements.getAllAnnouncements({
        limit,
        page,
        search,
      })
    },
    {
      select(data) {
        data?.data?.forEach((announcement) => {
          announcement.publish_date = moment(announcement.publish_date).format(
            'MMMM D, YYYY'
          )
          announcement.computedActions = [0]
        })

        return data
      },
      onSettled: (data, error, variables, context) => {
        store.dispatch(setIsLoading(false))
      },
      // keepPreviousData: true
    }
  )
}


export function useGetUnreadAnnouncements(limit, page, search) {
  return useQuery(
    ['unread-announcements', { limit, page, search }],
    () => {
      store.dispatch(setIsLoading(true))
      return announcements.getUnreadAnnouncements({
        limit,
        page,
        search,
      })
    },
    {
      select(data) {
        data?.data?.forEach((announcement) => {
          announcement.publish_date = moment(announcement.publish_date).format(
            'MMMM D, YYYY'
          )
          announcement.computedActions = [0]
        })

        return data
      },
      onSettled: (data, error, variables, context) => {
        store.dispatch(setIsLoading(false))
      },
      // keepPreviousData: true
    }
  )
}

export function useGetSingleAnnouncement(id) {
  return useQuery(
    ['single-announcement', { id }],
    () => {
      store.dispatch(setIsLoading(true))
      return announcements.getSingleAnnouncement(id)
    },
    {
      enabled: !!id,
      onSuccess: (response, variables, context) => {
        store.dispatch(setAlert(true, 'success', response.message))
      },
      onSettled: (data, error, variables, context) => {
        store.dispatch(setIsLoading(false))
      },
    }
  )
}

export function useAddAnnouncementComment() {
  return useMutation(
    (payload) => {
      store.dispatch(setIsLoading(true))
      return announcements.addAnnouncementComment(payload)
    },
    {
      onSuccess: (response, variables, context) => {
        queryClient.invalidateQueries('all-announcements')
        queryClient.invalidateQueries('unread-announcements')
        queryClient.invalidateQueries('single-announcement')
        store.dispatch(setAlert(true, 'success', response.message))
      },
      onSettled: (data, error, variables, context) => {
        store.dispatch(setIsLoading(false))
      },
    }
  )
}

export function useAddAnnouncementReaction() {
  return useMutation(
    (payload) => {
      store.dispatch(setIsLoading(true))
      return announcements.addAnnouncementReaction(payload)
    },
    {
      onSuccess: (response, variables, context) => {
        queryClient.invalidateQueries('all-announcements')
        queryClient.invalidateQueries('unread-announcements')
        queryClient.invalidateQueries('single-announcement')
        store.dispatch(setAlert(true, 'success', response.message))
      },
      onSettled: (data, error, variables, context) => {
        store.dispatch(setIsLoading(false))
      },
    }
  )
}

export function useOpenAnnouncement() {
  return useMutation(
    (payload) => {
      store.dispatch(setIsLoading(true))
      return announcements.openAnnouncement(payload)
    },
    {
      onSuccess: (response, variables, context) => {
        queryClient.invalidateQueries('all-announcements')
        queryClient.invalidateQueries('unread-announcements')
        queryClient.invalidateQueries('single-announcement')
        store.dispatch(setAlert(true, 'success', response.message))
      },
      onSettled: (data, error, variables, context) => {
        store.dispatch(setIsLoading(false))
      },
    }
  )
}

